import QueryString from 'qs';
import { toast } from 'react-toastify';
import { authAxiosInstance } from '../../utils/axiosConfig';
import { showError } from '../../utils/Utils';

export const fetchMillReceives = async (data) => {
    try {
        const string = QueryString.stringify(data);
        const receiveResp = await authAxiosInstance.get(
            `/millDispatch/receive?${string}`,
            data
        );
        return receiveResp.data;
    } catch (error) {
        console.log(error);
        toast.error('failed to fetch mill receives');
    }
};

export const deleteMillReceive = async (id) => {
    try {
        const receiveResp = await authAxiosInstance.delete(
            `/millDispatch/receive/${id}`
        );
        return receiveResp.data;
    } catch (error) {
        console.log(error);
        showError(error);
    }
};
